module.exports = __webpack_public_path__ + "static/media/03_avatar_female.f2cf7c99.png";